import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	Output,
	EventEmitter,
	Input
} from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { NotificationService } from 'src/app/services/notification.service'
import { DemandAttach, ListDemandHistory } from 'src/app/models/Demand'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { PATH } from 'src/app/app.api'
import * as moment_ from 'moment'
import { getIdentifierName, getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { DemandService } from 'src/app/services/demand.service'

@Component({
	selector: 'app-demands-attach',
	templateUrl: './demands-attach.component.html'
})

export class DemandsForAttachComponent implements OnInit {

	@Input() public appraisals: Array<ListDemandHistory> = []
	@Output() public close: EventEmitter<any> = new EventEmitter()
	@Output() public closeAndUpdate: EventEmitter<any> = new EventEmitter()

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective
	@ViewChild('tableDemandsAttachConteiner')
	public tableConteiner: ElementRef<HTMLDivElement>

	public refreshTable: Subject<any> = new Subject()
	public updateDataTable = value => this.filterSearchTree(value)
	public datatableOptions: DataTables.Settings = {}
	public dataTableParams: any

	public ViewValidation: ViewValidation = new ViewValidation()
	public sessionUser: UserAdmin = getLoggedUser()
	public assignments: Array<string> = []
	public companyId: string = localStorage.getItem('companyId')
	public identifierName = getIdentifierName()
	public demands: Array<DemandAttach> = []
	public demandSelected: DemandAttach = null
	public dateStart: string = ''
	public dateEnd: string = ''
	public searchText: string = ''
	public idMongoFromNewDemand: string = ''
	public isAdmin: boolean = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
	public openModalAttach: boolean = false
	public existDifferentProcess: boolean = false
	public enableCreateNewDemand: boolean = false
	public openModalNewDemand: boolean = false

	constructor(
		public notificationService: NotificationService,
		private demandService: DemandService,
		private http: HttpClient
	) { }

	public async ngOnInit(): Promise<void> {
		this.fetchAssignmentFromSessionUser()
		await this.setupDatatables()

		document.querySelector('main').className = ''
		this.rerender()
	}

	public fetchAssignmentFromSessionUser(): void {
		this.sessionUser.assignments.forEach(assignment => {
			this.assignments.push(assignment)
		})

		this.enableCreateNewDemand = Boolean(
			this.assignments.includes('APPRAISAL_SCHEDULE_CREATE_DEMAND') ||
			this.isAdmin
		)
	}

	private async setupDatatables(): Promise<void> {
		this.datatableOptions = {
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			pagingType: 'full_numbers',
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: [5],
					type: 'date'
				},
				{
					targets: [5],
					type: 'date'
				}
			],
			order: [[5, 'desc']],
			orderMulti: true,
			serverSide: true,
			processing: true,

			ajax: (dataTablesParameters: any, callback) => {
				this.http
					.get<any>(`${PATH}/demand/attach?companyId=${this.companyId}&skip=${dataTablesParameters.start}&limit=${dataTablesParameters.length}&order=${dataTablesParameters.columns[dataTablesParameters.order[0].column].data}&typeOrder=${dataTablesParameters.order[0].dir}&search=${this.searchText}&dateStart=${this.dateStart}&dateEnd=${this.dateEnd}`)
					.subscribe(resp => {
						this.demands = resp.content
						this.dataTableParams = dataTablesParameters
						callback({
							recordsFiltered: resp.numberOfPages,
							recordsTotal: resp.numberOfPages,
							data: []
						})
					})
			},
			columns: [
				{ data: 'protocol' },
				{ data: 'process' },
				{ data: 'treeId' , orderable: false},
				{ data: 'identifier' , orderable: false},
				{ data: 'date' },
				{ data: 'requester' },
				{ data: 'cpfRequester' },
				{ data: 'address' }
			]
		}
	}

	public async filterSearchTree(value: string): Promise<void> {

		const isData = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/

		if (isData.test(value)) {
			this.dateStart = moment_(value, 'DD/MM/YYYY').format(
				'YYYY-MM-DD'
			)
			this.dateEnd = moment_(value, 'DD/MM/YYYY').add('days', 1).format(
				'YYYY-MM-DD'
			)
		} else {
			this.dateStart = ''
			this.dateEnd = ''
			this.searchText = value
		}

		this.rerender()
	}

	public closeDemandsAttach() {
		this.close.emit()
	}

	public openModalAtach(demandSelected: DemandAttach) {
		this.demandSelected = demandSelected

		this.existDifferentProcess =
			this.appraisals.some(appraisal =>
				appraisal.process != '-' &&
				appraisal.process != demandSelected.process
			)

		this.openModalAttach = true
	}

	public closeModalAtach() {
		this.demandSelected = null
		this.openModalAttach = false
	}

	public async attachDemand() {
		this.notificationService.initLoading()

		const appraisalIds: Array<string> =
			this.appraisals.map(appraisal => appraisal.idMongo)

		const demandId = this.idMongoFromNewDemand ? this.idMongoFromNewDemand : this.demandSelected.idMongo

		try {
			const response =
				await this.demandService.attachDemandInAppraisal(
					appraisalIds,
					demandId
				).toPromise()

			this.notificationService.notify(response, 200)
			this.closeAndUpdate.emit()
		} catch (error) {
			console.log(`Erro ao atribuir a demanda ${demandId} a avaliação ${appraisalIds}. Error: ${error}`)
		}

		this.notificationService.stopLoading()
		this.closeModalAtach()
	}

	public getIdMongoFromNewDemand(idMongo: string) {
		this.idMongoFromNewDemand = idMongo

		this.attachDemand()
	}

	public openCloseNewDemand() {
		this.openModalNewDemand = !this.openModalNewDemand
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}
}
